import {Order} from "../bo/order";
import {isDelivery} from "./orders";
import {LatLng} from "../views/map";

export async function _calcRoute(origin: LatLng, destination: LatLng, orders: Order[], resolve: any, reject: any, map?: any) {

    function orderToLocation(order: Order) : LatLng {
        const address = isDelivery(order);
        return {lat: address.lat, lng: address.lng};
    }

    const postcodeToOrders: any = {};

    const waypointSeries: google.maps.DirectionsWaypoint[][] = [];

    let waypoints: google.maps.DirectionsWaypoint[] = [];

    // Distance in metres
    function distance(a: LatLng, b: LatLng) : number {
        return Math.sqrt((a.lat - b.lat)**2 + (Math.cos(a.lat * Math.PI / 180) * (a.lng - b.lng))**2) * 6371000 / 180;
    }

    const missingPostcodes : Order[] = [];
    const withPostcodes : Order[] = [];
    // Find any addresses with missing postcodes and assign them to the closest postcode
    for (const order of orders || []) {
        const address = isDelivery(order);

        if (address && address.geocoded) {
            if (address.zipCode) {
                withPostcodes.push(order);
            } else {
                missingPostcodes.push(order);
            }
        }
    }

    for (const order of missingPostcodes) {
        const address = isDelivery(order);
        const min : any = {};
        for (const o of withPostcodes) {
            const a = isDelivery(o);
            const z = distance(a, address);

            if (min.z === undefined || min.z > z) {
                min.z = z;
                min.postcode = a.zipCode;
            }
        }
        address.zipCode = min.postcode;
        console.log(`assigned ${address.zipCode} to ${address.addressLine1} ${address.city}`);

    }

    const UNKNOWN = "unknown postcode";

    for (const order of orders || []) {
        const address = isDelivery(order);
        const postcode = address && (address.zipCode || UNKNOWN);

        if (address && address.geocoded && postcode) {

            const position = {lat: address.lat, lng: address.lng};
            const w = {
                location: position,
                stopover: true,
            };

            waypoints.push(w);

            if (!postcodeToOrders[postcode]) {
                postcodeToOrders[postcode] = [];
            }
            postcodeToOrders[postcode].push(order);
        } else {
        }

    }

    const MAX = 23;
    if (waypoints.length > MAX) {
        // Break up into postcodes

        const w2: any[] = [];
        const postcodes = [];
        const done: any = {};
        for (const order of orders) {
            const address = isDelivery(order);
            const postcode = address.zipCode || UNKNOWN;
            if (address && address.geocoded && postcode) {
                if (!done[postcode]) {
                    done[postcode] = address;

                    const position = {lat: address.lat, lng: address.lng};
                    const w = {
                        location: position,
                        stopover: true,
                    };

                    w2.push(w);
                    postcodes.push(postcode);

                    //console.log(`postcode ${postcode} mapped to ${address.addressLine1} ${address.city}`);
                } else {
                    const a = done[postcode];
                    //console.log(`postcode ${postcode} USED ${a.addressLine1} ${a.city} FOR ${address.addressLine1} ${address.city}`);
                }
            }
        }

        console.log(`reduced waypoints from ${waypoints.length} to ${w2.length}`);

        const request = {
            origin: origin,
            destination: destination,
            waypoints: w2,
            optimizeWaypoints: true,
            provideRouteAlternatives: false,
            travelMode: google.maps.TravelMode.DRIVING,
            drivingOptions: {
                departureTime: new Date(),
                trafficModel: google.maps.TrafficModel.BEST_GUESS,
            },
            unitSystem: google.maps.UnitSystem.METRIC
        };

        const directionsService = new google.maps.DirectionsService();
        const rough = await directionsService.route(request);

        const waypointOrder = rough.routes[0].waypoint_order;

        let w3: any[] = [];

        function flush() {
            if (w3.length > 0) {
                console.log(`flush ${w3.length}`);
                waypointSeries.push(w3);
                w3 = [];
            }
        }

        while (waypointOrder.length > 0) {

            const nextIndex = waypointOrder.shift();
            if (nextIndex !== undefined) {

                const nextPostcode = postcodes[nextIndex];
                const nextOrders = postcodeToOrders[nextPostcode];

                console.log(`nextPostcode=${nextPostcode} orders in postcode=${nextOrders.length} already w3=${w3.length}`);

                if (w3.length + nextOrders.length > MAX && w3.length > 0) {
                    flush();
                }

                for (const order of nextOrders) {
                    const address = isDelivery(order);
                    const position = {lat: address.lat, lng: address.lng};
                    const w = {
                        location: position,
                        stopover: true,
                    };

                    w3.push(w);
                }
            }
        }

        flush();

    } else {
        waypointSeries.push(waypoints);
    }

    let out: google.maps.DirectionsResult[] = [];

    let done = 0;

    const orderedOrders : Order[] = [];
    const doneOrderedOrders : any = {};

    function addOrderedOrder(order: Order) {

        if (! doneOrderedOrders[order.id as string]) {
            orderedOrders.push(order);
            doneOrderedOrders[order.id as string] = true;
        }
    }

    for (const order of orders) {
        const address = isDelivery(order);
        if (! address || ! address.geocoded) {
            addOrderedOrder(order);
        }
    }

    /**
     * Clean up in case any non-geocoded orders have not been dealt with
     */
    function addRemaining() {
        for (const order of orders) {
            if (orderedOrders.indexOf(order) == -1) {
                orderedOrders.push(order);
            }
        }
    }

    for (const i in waypointSeries) {

        const w = waypointSeries[i];

        const org = +i == 0 ? origin : waypointSeries[+i - 1][waypointSeries[+i - 1].length - 1].location as LatLng;
        const dest = +i == waypointSeries.length - 1 ? destination : waypointSeries[+i + 1][0].location as LatLng;

        const request = {
            origin: org,
            destination: dest,
            waypoints: w,
            optimizeWaypoints: true,
            provideRouteAlternatives: false,
            travelMode: google.maps.TravelMode.DRIVING,
            drivingOptions: {
                departureTime: new Date(),
                trafficModel: google.maps.TrafficModel.BEST_GUESS,
            },
            unitSystem: google.maps.UnitSystem.METRIC
        };

        const directionsService = new google.maps.DirectionsService();
        directionsService.route(request, (result, status) => {
            console.log("Route", result, status);
            if (status == "OK") {

                if (map) {
                    const directionsRenderer = new google.maps.DirectionsRenderer({
                        suppressMarkers: true
                    });
                    directionsRenderer.setMap(map);

                    directionsRenderer.setDirections(result);
                }

                console.log(`waypoint series ${i} of ${waypointSeries.length} gives`, result);

                // --------------------------------

                for (const route of (result?.routes || [])) {

                    for (let l = 1; l < route.legs.length; l++) {
                        const leg = route.legs[l];
                        // console.log("---------------------------------------", leg);

                        // Find the order that is closest to the leg start - we take this to be the relevant order

                        const min : any = {
                            z: undefined,
                            orders: []
                        };
                        for (const order of orders) {
                            if (! isDelivery(order)) {
                                continue;
                            }
                            const legpos = {lat: leg.start_location.lat(), lng: leg.start_location.lng()};

                            const z = distance(legpos, orderToLocation(order));

                            console.log(`    distance =${z} to address=${isDelivery(order).addressLine1}`);

                            if (min.z === undefined || min.z > z) {
                                min.z = z;
                                min.orders = [order];
                            } else if (min.z === z && min.orders) {
                                min.orders.push(order);
                            }
                        }

                        for (const order of min.orders) {
                            console.log(`distance =${min.z} address=${isDelivery(order).addressLine1}`); 
                            addOrderedOrder(order);
                        }
                    }
                }

                // --------------------------------

                if (result != null) {
                    out.push(result);
                }

                done ++;

                if (done == waypointSeries.length) {

                    addRemaining();

                    resolve({
                        results: out,
                        orderedOrders: orderedOrders
                    });
                }
            } else {
                reject("Failed");
            }
        });

    }

    if (waypointSeries.length == 0) {
        console.log(`returning ${out.length} waypoint series results`);
        resolve({
            results: out,
            orderedOrders: orderedOrders
        });
    }

}

